import { Controller } from '@hotwired/stimulus'

// Clinic photo gallery: a main image plus thumbnail buttons. Thumbnails are real
// <button>s (Enter/Space select them natively); arrow keys move between them.
// No autoplay or transitions, so there is nothing to disable for reduced motion.
export default class extends Controller<HTMLElement> {
  static targets = ['main', 'thumb']

  declare readonly mainTarget: HTMLImageElement
  declare readonly hasMainTarget: boolean
  declare readonly thumbTargets: HTMLElement[]

  index = 0

  select(event: Event): void {
    this.show(this.thumbTargets.indexOf(event.currentTarget as HTMLElement))
  }

  keydown(event: KeyboardEvent): void {
    if (event.key === 'ArrowRight') {
      event.preventDefault()
      this.move(1)
    } else if (event.key === 'ArrowLeft') {
      event.preventDefault()
      this.move(-1)
    }
  }

  private move(delta: number): void {
    const count = this.thumbTargets.length
    if (count === 0) return
    const next = (this.index + delta + count) % count
    this.show(next)
    this.thumbTargets[next].focus()
  }

  private show(i: number): void {
    const thumb = this.thumbTargets[i]
    if (!thumb || !this.hasMainTarget) return
    this.index = i
    if (thumb.dataset.src) this.mainTarget.src = thumb.dataset.src
    if (thumb.dataset.alt) this.mainTarget.alt = thumb.dataset.alt
    this.thumbTargets.forEach((t, n) => {
      t.setAttribute('aria-current', String(n === i))
      t.style.borderColor = n === i ? 'var(--color-primary)' : 'transparent'
    })
  }
}
